import { Document } from '@contentful/rich-text-types';
import RichTitle from '@/components/ui/RichTitle';
import { cn } from '@/utils/cn';

type SectionHeaderProps = {
  eyebrow?: string;
  title: Document;
  className?: string;
  titleClassName?: string;
  titleId?: string;
};

export default function SectionHeader({
  eyebrow,
  title,
  className,
  titleClassName,
  titleId,
}: SectionHeaderProps) {
  return (
    <div className={className}>
      {eyebrow && (
        <span className="inline-block border-[1.5px] border-primary text-primary font-sans text-[0.6rem] font-bold tracking-[0.22em] uppercase px-3 py-1 mb-4">
          {eyebrow}
        </span>
      )}
      <RichTitle
        doc={title}
        as="h2"
        id={titleId}
        className={cn(
          'font-serif text-[clamp(1.8rem,2.8vw,3rem)] font-normal italic leading-[1.2] text-text',
          titleClassName,
        )}
      />
    </div>
  );
}
